<div class="notification-item-container">
  <input
    type="checkbox"
    class="check-notif-type"
    [checked]="enabled"
    (change)="toggleEnabled()"
  />
  <div class="notification-type-container">
    <div class="header">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
    </div>
    <div class="channels">
      <span style="font-weight: bold; color: #353b40">Channel:</span>

      <label class="channel">
        <input
          type="checkbox"
          [checked]="channels.sms"
          (change)="toggleChannel('sms')"
        />
        <span>SMS/Text</span>
      </label>

      <!-- <label class="channel">
        <input
          type="checkbox"
          [checked]="channels.whatsapp"
          (change)="toggleChannel('whatsapp')"
        />
        <span>WhatsApp</span>
      </label> -->

      <label class="channel">
        <input
          type="checkbox"
          [checked]="channels.email"
          (change)="toggleChannel('email')"
        />
        <span>Email</span>
      </label>
    </div>
  </div>
</div>
